import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import logo from '../../assets/images/logo.png';

const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#0F1114] flex flex-col">
      {/* Header */}
      <header className="py-6 px-4">
        <Link to="/" className="flex items-center justify-center gap-2">
          <img src={logo} alt="CricClash" className="w-10 h-10 rounded-lg object-cover" />
          <span className="text-xl font-bold text-white">CricClash</span>
        </Link>
      </header>

      {/* Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer className="py-4 text-center text-sm text-gray-500">
        <p>&copy; {new Date().getFullYear()} CricClash. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default AuthLayout;
